<!--
 * @Author: Narcissus
 * @Date: 2022-10-26 11:26:12
 * @LastEditTime: 2022-11-02 14:22:54
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \hi-tom\src\layout\components\head-decorate\index.vue
-->
<!--  -->
<template>
  <div class="head_decorate">
    <div class="decorate_area" v-if="is_decorate_area === true">
      <h3 class="decorate_header">{{ decorate_header2 }}</h3>
      <p class="decorate_line">{{ decorate_line2 }}</p>
    </div>
    <div class="decorate_area" v-else>
      <h3 class="decorate_header">{{ decorate_header }}</h3>
      <p class="decorate_line">{{ decorate_line }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      decorate_header: 'Hi-TOM 2.0',
      decorate_line: 'An improved platform for high-throughput mutation detection',//An Improved Platform for High-throughput Tracking of DNA Methylation and Mutation Detection
      decorate_header2: 'Have a Question?',
      decorate_line2: 'If You Have Any Question You Can Ask Below!',
      is_decorate_area: false,
    };
  },

  components: {},

  computed: {},

  mounted() {
    // console.log('路由');
    // console.log(this.$route.path);
    if (this.$route.path === '/contact') {
      this.is_decorate_area = true
    } else {
      this.is_decorate_area = false
    }
  },

  methods: {}
}

</script>
<style scoped>
.head_decorate {
  width: 100%;
  background: #353b65 url(../../../assets/main-bg.jpg) center top no-repeat;
  background-size: 100% 100%;
  min-height: 120px;
  height: auto !important;
}

.decorate_area {
  padding: 10px 0;
}

.decorate_header {
  font-family: "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 36px;
  color: #fff;
  text-align: center;
}

.decorate_line {
  font-family: "Droid Serif", serif;
  font-style: italic;
  font-size: 18px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/head-decorate/index.vue